export default __webpack_public_path__ + "static/Design-projecao-para-o-desenvolvimento-64aad6200c9c9fdde57e214477b78dff.png";